import React from 'react'
import { Link } from 'react-router-dom'


const Foster = () => {
  return (
    <div>
    <footer className="foster"  >
    <p>Copyright &copy; 2022</p>
    <Link to="/about">About</Link>
    </footer>
  
    </div>
  )
}

export default Foster;